import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import moment from 'moment';
import { reduce, uniq, find, first, intersection,
  concat, groupBy, keys } from 'lodash';
import { Dropdown, MenuItem } from 'react-bootstrap';
import { fetchNews, resetNotifications } from '../../NewsActions';
import { getNews, getLoading, getHasErrors } from '../../NewsReducer';
import ProgressBar from '../../../../components/progress-bar';
import NewsItem from '../../components/NewsItem';
import TypeDropdown from './TypeDropdown';

class NewsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      period: null,
      types: [],
      availableTypes: [],
      availableYears: [],
    };
    this.handleTypeChange = this.handleTypeChange.bind(this);
    this.setPeriod = this.setPeriod.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(fetchNews())
      .then(({ news }) => {
        const availableTypes = reduce(news, (items, n) => concat(items, n.types), []);
        const availableYears = keys(groupBy(news, n => moment(n.announcement_date).format('YYYY')));
        this.setState({ availableTypes: uniq(availableTypes), availableYears: availableYears.sort() });
        this.props.dispatch(resetNotifications());
      });
  }

  setPeriod(period) {
    this.setState({ period });
  }
  handleTypeChange(types) {
    this.setState({ types });
  }

  renderRangeDropdown() {
    const { availableYears, period } = this.state;
    const options = [
      { value: null, label: 'All' },
      { value: 'd1', divider: true },
      { value: 'this-month', label: moment().format('MMM YYYY') },
      ...(availableYears.length > 0 ? [{ value: 'd2', divider: true }] : []),
      ...(availableYears.map(y => ({ value: y, label: y }))),
    ];
    const activePeriod = find(options, { value: period }) || first(options);
    return (
      <Dropdown
        id="ann-period-dropdown"
      >
        <Dropdown.Toggle bsSize="small">
          {activePeriod.label}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {options.map((s) => {
            if (s.divider) {
              return (
                <MenuItem divider key={s.value} />
              );
            }
            return (
              <MenuItem
                key={s.value}
                active={activePeriod.value === s.value}
                onSelect={() => { this.setPeriod(s.value); }}
              >
                {s.label}
              </MenuItem>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  renderControls() {
    const { availableTypes } = this.state;
    return (
      <div>
        <h5>
          Show&nbsp;
          {this.renderRangeDropdown()}
          &nbsp;
          <TypeDropdown
            availableTypes={availableTypes}
            onTypeChange={this.handleTypeChange}
          />
          &nbsp;announcements.
        </h5>
        <p>&nbsp;</p>
      </div>
    );
  }

  renderResults() {
    const { news } = this.props;
    const { period, types } = this.state;
    const grandTotal = news.length;
    const sortedData = reduce(news, (items, n) => {
      let byPeriod = true;
      let byTypes = true;
      if (period) {
        const thisMonth = moment();
        if (!n.$announcement_date) {
          n.$announcement_date = moment(n.announcement_date);
        }
        if (period === 'this-month') {
          if (!n.$announcement_date.isSame(thisMonth, 'month')) {
            byPeriod = false;
          }
        } else if (n.$announcement_date.format('YYYY') !== period) {
          // year
          byPeriod = false;
        }
      }
      if (types.length > 0) {
        const nTypes = intersection(n.types || [], types);
        byTypes = nTypes.length > 0;
      }
      if (byPeriod && byTypes) {
        items.push(n);
      }
      return items;
    }, []);

    const hasSortedData = sortedData.length > 0;

    return (
      <div>
        {grandTotal > 0 && this.renderControls()}
        {hasSortedData &&
          <div>
            {sortedData.map(n => (
              <NewsItem news={n} key={n._id} />
            ))}
          </div>
        }
        {!hasSortedData &&
          <div className="well">
            No Announcements at the moment. Please check again later.
          </div>
        }
      </div>
    );
  }

  render() {
    const { loading, hasErrors } = this.props;
    return (
      <div>
        <Helmet title="Announcements" />
        <div className="container">
          <h1 className="page-header">
            TruSales Updates
          </h1>
          {loading && <ProgressBar />}
          {!loading && !hasErrors && this.renderResults()}
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    loading: getLoading(state),
    hasErrors: getHasErrors(state),
    news: getNews(state),
  };
}

NewsPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  hasErrors: PropTypes.bool,
  news: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string.isRequired,
  })),
};

NewsPage.defaultProps = {
  loading: false,
  hasErrors: false,
  news: [],
};

NewsPage.contextTypes = {
  router: PropTypes.object,
};

export default connect(mapStateToProps)(NewsPage);
